import { useMatch } from 'react-router-dom';

import { useGetSpaceCredits } from '@/entities/teamspace';

import { PATHS } from '@/shared/constants/routes/paths';
import { getRecordingEntitlement, RecordingEntitlement } from '@/shared/lib/billing/recordingEntitlement';

import { useIsPaidTrial } from './useIsPaidTrial';

const SPACE_ROUTE_PATTERN = `/${PATHS.spaces}/:spaceId/*`;

export const useRecordingEntitlement = (spaceId?: string): RecordingEntitlement => {
  const spaceMatch = useMatch(SPACE_ROUTE_PATTERN);
  const { data: spaceCredits } = useGetSpaceCredits(spaceId ?? spaceMatch?.params.spaceId ?? '');
  const isPaidTrial = useIsPaidTrial(spaceCredits?.subscription);

  if (isPaidTrial === undefined) return { status: 'loading' };
  return getRecordingEntitlement(spaceCredits, isPaidTrial);
};

export const useHasUnlimitedRecordingMinutes = (spaceId?: string): boolean =>
  useRecordingEntitlement(spaceId).status === 'unlimited';
